"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
const isError = function (ex) {
    return (typeof ex === 'object' &&
        ex !== null &&
        'message' in ex && typeof ex.message === 'string' &&
        'name' in ex && typeof ex.name === 'string');
};
exports.isError = isError;
